/* Scoped enhancement; native Shopify product form works without JavaScript. */
(() => {
  if (customElements.get('replica-product')) return;
  class ReplicaProduct extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.select = this.querySelector('[data-variant-select]');
      const options = this.querySelector('[data-options]');
      this.gallery = this.querySelector('.rp-gallery');
      const controls = this.querySelector('[data-gallery-controls]');
      if (controls && this.gallery.children.length > 1) controls.hidden = false;
      this.gallery.addEventListener('scroll', () => {
        const width = this.gallery.clientWidth + 8;
        const count = this.querySelector('[data-gallery-count]');
        if (count && width > 8) count.textContent = `${Math.round(this.gallery.scrollLeft / width) + 1} / ${this.gallery.children.length}`;
      }, {passive:true});
      if (options || this.select.options.length === 1) {
        this.select.hidden = true;
        this.querySelector('.rp-select-label').hidden = true;
        if (options) options.hidden = false;
      }
      this.addEventListener('click', e => {
        const button = e.target.closest('[data-variant]');
        if (button) this.change(button.dataset.variant, true);
        if (e.target.closest('[data-gallery-prev]')) this.gallery.scrollBy({left: -(this.gallery.clientWidth + 8), behavior:'smooth'});
        if (e.target.closest('[data-gallery-next]')) this.gallery.scrollBy({left: this.gallery.clientWidth + 8, behavior:'smooth'});
        const zoom = e.target.closest('[data-zoom]');
        if (zoom && this.querySelector('dialog').showModal) {
          e.preventDefault();
          this.lastZoom = zoom;
          const dialog = this.querySelector('dialog');
          const img = dialog.querySelector('img');
          img.src = zoom.href; img.alt = zoom.querySelector('img').alt;
          dialog.showModal();
        }
        if (e.target.closest('[data-close]')) this.querySelector('dialog').close();
      });
      this.select.addEventListener('change', () => this.change(this.select.value, true));
      const dialog = this.querySelector('dialog');
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => this.lastZoom?.focus());
      this.onPop = () => { const id = new URL(location.href).searchParams.get('variant'); if (id) this.change(id, false); };
      window.addEventListener('popstate', this.onPop);
      this.change(this.select.value, false);
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.onPop); this.ready = false; }
    change(id, updateUrl) {
      const variant = this.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      this.select.value = String(variant.id);
      this.querySelectorAll('[data-variant]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.variant === String(variant.id))));
      this.querySelector('[data-price]').textContent = variant.price;
      const compare = this.querySelector('[data-compare]');
      compare.textContent = variant.compare; compare.hidden = !variant.onSale;
      this.querySelector('[data-size]').textContent = variant.size || '';
      const add = this.querySelector('[data-add]');
      add.disabled = !variant.available; add.textContent = variant.available ? 'Add to Cart' : 'Sold out';
      const media = this.querySelector(`[data-media-id="${variant.mediaId}"]`);
      if (media) {
        this.querySelectorAll('.rp-media').forEach(el => el.classList.toggle('rp-media-first', el === media));
        media.parentNode.prepend(media);
        this.gallery.scrollTo({left:0,behavior:'instant'});
      }
      if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', id); history.replaceState({}, '', url); }
    }
  }
  customElements.define('replica-product', ReplicaProduct);
})();
